import { css } from "@emotion/react";

export const styModalConfirmGift = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;
`;

export const styModalConfirmGiftContent = css`
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  width: 350px;
`;

export const styMoodalConfirmGiftTitle = css`
  margin-top: 0;
`;

export const styFormItem = css`
  margin-bottom: 10px;
`;

export const styInput = css`
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const styButton = css`
  margin: 0 8px;
`;
